const { createContext, useState, useContext } = require("react");

const AuthContext = createContext(null)

export const AuthContextProvider = ({ children }) => {
	const storedAuth = localStorage.getItem('isAuthenticated') === 'true'
    const [isAuthenticated, setIsAuthenticated] = useState(storedAuth)

    return (<AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated }}>
        {children}
    </AuthContext.Provider>)
}


export const useAuth = () => {
    const context = useContext(AuthContext)
    if (!context) throw new Error('Out of context boundary')
    return context
}
